export enum ORGANIZATION_TYPE {
    Provider = 0,
    Customer,
}

export const numberToOrgType = (n: number): string => {
    return ORGANIZATION_TYPE[n];
};

export type IOrganizationModel = {
    id?: string | number;
    name: string;
    email: string;
    displayName: string;
    status?: any,
    type: string;
    url: string;
    locale?: string;
    billingDefinitions?: any,
    referenceId?: string
    businessType?: string
    notifyUsers?: string[];
    applications?: any;
    enableMFA?: boolean;
    typeMFA?: any;
};  